import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import MotivosOuvidoriaFilter from './MotivosOuvidoriaFilter';
import MotivosOuvidoriaHeader from './MotivosOuvidoriaHeader';
import MotivosOuvidoriaTable from './MotivosOuvidoriaTable';
import { useMotivosOuvidoriaListagem, useMotivosOuvidoriaNavegacao } from '../hooks';

const MotivosOuvidoriaCard = ({
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true,
}) => {
  const {
    data,
    loading,
    filterLoading,
    deleteLoading,
    showDeleteModal,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    filtrosUI,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    handleCancelarExclusao,
    handleConfirmarExclusao,
    setPaginaAtual,
    setQuantidadePorPagina,
  } = useMotivosOuvidoriaListagem();

  const { handleAdicionar, handleEditar, handleRowClick } = useMotivosOuvidoriaNavegacao();

  return (
    <Card>
      <CardBody>
        {showHeader && (
          <MotivosOuvidoriaHeader
            totalRegistros={totalRegistros}
            onAdicionar={showActions ? handleAdicionar : undefined}
          />
        )}

        {showFilter && (
          <MotivosOuvidoriaFilter
            loading={filterLoading}
            values={filtrosUI}
            onApply={handleFilterApply}
            onLimpar={handleLimparFiltros}
          />
        )}

        <MotivosOuvidoriaTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={{
            pageIndex: Math.max(0, (paginaAtual || 1) - 1),
            pageSize: quantidadePorPagina || 10,
          }}
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') {
              setQuantidadePorPagina(next.pageSize);
            }

            if (next && typeof next.pageIndex === 'number') {
              setPaginaAtual(next.pageIndex + 1);
            }
          }}
        />

        <ConfirmDeleteModal
          show={showDeleteModal}
          onClose={handleCancelarExclusao}
          onConfirm={handleConfirmarExclusao}
          loading={deleteLoading}
          title="Excluir motivo da ouvidoria"
          message="Tem certeza que deseja excluir este motivo da ouvidoria? Esta acao nao pode ser desfeita."
        />
      </CardBody>
    </Card>
  );
};

export default MotivosOuvidoriaCard;
